import { Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import { productCenterContent } from '@/mocks/products';

// 用户将提供实际平台链接，替换此处即可
const PLATFORM_URL = '#';

const features = [
  {
    title: '工作台',
    subtitle: '关键指标与设备状态一屏掌握',
    desc: '工作台集中呈现平台运行指标、设备数量、挂载与按压趋势及 UKey 实时状态，帮助管理人员快速掌握整体运行态势。',
    points: [
      '平台运行与设备状态总览',
      '设备数量、挂载与按压趋势统计',
      'UKey 实时状态监控',
      '关键指标一屏掌握，快速洞察运行态势',
    ],
    image:
      'https://readdy.ai/api/search-image?query=Modern%20minimalist%20enterprise%20dashboard%20visualization%20with%20metric%20cards%20and%20flowing%20trend%20lines%20representing%20device%20status%20monitoring%2C%20clean%20dark%20charcoal%20and%20warm%20neutral%20tones%2C%20professional%20corporate%20SaaS%20interface%20aesthetic%2C%20soft%20ambient%20lighting%2C%20no%20blue%20or%20purple%20colors%2C%20elegant%20restrained%20data%20presentation%2C%20abstract%20UI%20composition&width=800&height=500&seq=shield-workbench-01&orientation=landscape',
    icon: 'ri-dashboard-line',
    reverse: false,
  },
  {
    title: '授权管理',
    subtitle: '人员、设备与有效期精细控制',
    desc: '授权管理支持按人员或设备双向查询，并灵活配置授权对象、账号范围与有效时间，实现权限关系清晰可查、授权过程可控。',
    points: [
      '授权信息列表：清晰展示全部授权关系',
      '设备授权人员查询：按设备反向查询授权人员',
      '新建授权与数据范围配置：灵活设定授权对象、账号范围与有效期',
      '权限关系清晰可查，授权过程全程可控',
    ],
    image:
      'https://readdy.ai/api/search-image?query=Modern%20minimalist%20authorization%20management%20interface%20visualization%20with%20personnel%20lists%20and%20permission%20configuration%20panels%2C%20clean%20dark%20charcoal%20and%20warm%20neutral%20tones%2C%20professional%20corporate%20SaaS%20aesthetic%2C%20soft%20ambient%20lighting%2C%20no%20blue%20or%20purple%20colors%2C%20elegant%20restrained%20UI%20composition%2C%20abstract%20data%20table%20representation&width=800&height=500&seq=shield-auth-01&orientation=landscape',
    icon: 'ri-shield-user-line',
    reverse: true,
  },
  {
    title: 'UKey 管理',
    subtitle: '设备建档与业务信息统一维护',
    desc: 'UKey 管理覆盖设备新增、状态查看、银行账号与业务信息配置，形成从设备纳管到业务使用的完整档案。',
    points: [
      'UKey 设备列表：统一管理全部设备信息',
      '业务信息与账号配置：关联银行账号与业务属性',
      '新建设备与业务信息：快速录入并建档',
      '从设备纳管到业务使用的完整闭环',
    ],
    image:
      'https://readdy.ai/api/search-image?query=Modern%20minimalist%20UKey%20device%20management%20interface%20with%20structured%20device%20lists%20and%20configuration%20forms%2C%20clean%20dark%20charcoal%20and%20warm%20neutral%20tones%2C%20professional%20corporate%20SaaS%20aesthetic%2C%20soft%20ambient%20lighting%2C%20no%20blue%20or%20purple%20colors%2C%20elegant%20restrained%20composition%2C%20abstract%20hardware%20inventory%20visualization&width=800&height=500&seq=shield-ukey-01&orientation=landscape',
    icon: 'ri-key-2-line',
    reverse: false,
  },
  {
    title: '全部 UKey',
    subtitle: '跨组织设备与操作状态集中查看',
    desc: '全部 UKey 统一汇总各组织设备、挂载状态、占用情况和节点信息，并支持批量操作与状态更新，提升设备调度效率。',
    points: [
      '全部 UKey 设备与操作列表：跨组织集中展示',
      '统一汇总各组织设备、挂载状态与占用情况',
      '节点信息一目了然，资源调度有据可依',
      '支持批量操作与状态更新，提升调度效率',
    ],
    image:
      'https://readdy.ai/api/search-image?query=Modern%20minimalist%20cross%20organizational%20device%20monitoring%20dashboard%20with%20unified%20equipment%20lists%20and%20batch%20operation%20controls%2C%20clean%20dark%20charcoal%20and%20warm%20neutral%20tones%2C%20professional%20corporate%20SaaS%20aesthetic%2C%20soft%20ambient%20lighting%2C%20no%20blue%20or%20purple%20colors%2C%20elegant%20restrained%20composition%2C%20abstract%20centralized%20management%20visualization&width=800&height=500&seq=shield-allukey-01&orientation=landscape',
    icon: 'ri-stack-line',
    reverse: true,
  },
];

export default function ProductShieldDetail() {
  const product = productCenterContent.items.find(
    (item) => item.slug === 'shield-platform',
  );
  const otherProducts = productCenterContent.items.filter(
    (item) => item.slug !== 'shield-platform',
  );

  if (!product) return null;

  return (
    <div className="min-h-screen bg-background-50">
      <Navbar />
      <main>
        {/* Header */}
        <section className="pt-28 md:pt-36 pb-10 md:pb-14 bg-background-50">
          <div className="w-full px-4 md:px-8 lg:px-12 xl:px-20 max-w-[1400px] mx-auto">
            <nav className="mb-8 flex items-center gap-2 text-sm text-foreground-300">
              <Link to="/" className="hover:text-primary-400 transition-colors">
                首页
              </Link>
              <i className="ri-arrow-right-s-line" />
              <Link
                to="/product-center"
                className="hover:text-primary-400 transition-colors"
              >
                产品中心
              </Link>
              <i className="ri-arrow-right-s-line" />
              <span className="text-foreground-100 font-medium">
                {product.titleCn}
              </span>
            </nav>

            <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-8">
              <div className="max-w-3xl">
                <div className="flex items-center gap-3 mb-5">
                  <div className="w-12 h-12 flex items-center justify-center rounded-lg bg-primary-500 text-foreground-50">
                    <i className={`${product.icon} text-2xl`} />
                  </div>
                  <span className="text-sm font-medium text-primary-400 tracking-wide font-label">
                    {product.titleEn}
                  </span>
                </div>
                <h1 className="text-3xl md:text-5xl font-black text-foreground-50 font-heading">
                  {product.titleCn}
                </h1>
                <p className="mt-5 text-base md:text-lg text-foreground-300 leading-relaxed max-w-2xl">
                  {product.desc}
                </p>
              </div>
            </div>
          </div>
        </section>

        {/* Intro */}
        <section className="pb-16 md:pb-24 bg-background-50">
          <div className="w-full px-4 md:px-8 lg:px-12 xl:px-20 max-w-[1400px] mx-auto">
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 lg:gap-16 items-center">
              <div>
                <div className="flex items-center gap-3 mb-4">
                  <h2 className="text-xl md:text-2xl font-bold text-foreground-50 font-heading">
                    产品介绍
                  </h2>
                  <div className="flex-1 h-px bg-background-200/60" />
                </div>
                <p className="text-sm md:text-base text-foreground-300 leading-loose">
                  {product.intro}
                </p>
                <div className="mt-8 flex flex-wrap gap-3">
                  {[
                    'U盾智能管理',
                    'AI识别认证',
                    '国密加密',
                    '资金安全可视化',
                  ].map((tag) => (
                    <span
                      key={tag}
                      className="inline-flex items-center px-4 py-2 rounded-full bg-background-100 text-sm text-foreground-300 border border-background-200/50"
                    >
                      {tag}
                    </span>
                  ))}
                </div>
              </div>
              <div className="relative rounded-lg overflow-hidden border border-background-200/50">
                <img
                  src={product.image}
                  alt={product.titleCn}
                  title={`${product.titleCn} ${product.titleEn}`}
                  className="w-full h-64 md:h-80 object-cover object-top"
                />
              </div>
            </div>
          </div>
        </section>

        {/* Core capabilities from mock data */}
        <section className="bg-background-100 py-16 md:py-24">
          <div className="w-full px-4 md:px-8 lg:px-12 xl:px-20 max-w-[1400px] mx-auto">
            <div className="flex items-end justify-between">
              <div>
                <h2 className="text-xl md:text-2xl font-bold text-foreground-50 font-heading">
                  核心能力
                </h2>
                <div className="mt-4 w-12 h-0.5 bg-primary-500 rounded-full" />
              </div>
              <span className="hidden sm:block text-sm text-foreground-300 font-label">
                共 {product.features.length} 项
              </span>
            </div>

            <div className="mt-12 grid grid-cols-1 sm:grid-cols-2 gap-6 md:gap-8">
              {product.features.map((feature, idx) => (
                <div
                  key={feature.title}
                  className="group relative bg-background-50 rounded-lg border border-background-200/50 p-8 md:p-10 overflow-hidden transition-all duration-300 hover:border-primary-500/40"
                >
                  <span className="absolute top-6 right-6 text-5xl md:text-6xl font-black text-background-200 group-hover:text-primary-400/20 transition-colors font-heading leading-none">
                    {String(idx + 1).padStart(2, '0')}
                  </span>
                  <div className="relative">
                    <div className="w-14 h-14 flex items-center justify-center rounded-lg bg-background-100 text-primary-500 mb-6 group-hover:bg-primary-500 group-hover:text-foreground-50 transition-colors">
                      <i className={`${feature.icon} text-2xl`} />
                    </div>
                    <h3 className="text-lg md:text-xl font-bold text-foreground-50">
                      {feature.title}
                    </h3>
                    <p className="mt-3 text-sm text-foreground-300 leading-relaxed">
                      {feature.desc}
                    </p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Feature showcase based on PPT slides */}
        <section className="py-16 md:py-24 bg-background-50">
          <div className="w-full px-4 md:px-8 lg:px-12 xl:px-20 max-w-[1400px] mx-auto">
            <div className="text-center mb-12 md:mb-16">
              <h2 className="text-xl md:text-2xl font-bold text-foreground-50 font-heading">
                功能详解
              </h2>
              <p className="mt-3 text-sm text-foreground-300">
                覆盖设备、授权、UKey 与跨组织管理的全域功能
              </p>
              <div className="mt-4 mx-auto w-12 h-0.5 bg-primary-500 rounded-full" />
            </div>

            <div className="space-y-20 md:space-y-28">
              {features.map((f, idx) => (
                <div
                  key={f.title}
                  className={`grid grid-cols-1 lg:grid-cols-2 gap-10 lg:gap-16 items-center ${
                    idx > 0
                      ? 'pt-20 md:pt-28 border-t border-background-200/30'
                      : ''
                  }`}
                >
                  <div className={f.reverse ? 'order-1 lg:order-2' : ''}>
                    <div className="flex items-center gap-3 mb-4">
                      <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-primary-500 text-foreground-50">
                        <i className={`${f.icon} text-lg`} />
                      </div>
                      <div>
                        <h3 className="text-lg md:text-xl font-bold text-foreground-50">
                          {f.title}
                        </h3>
                        <p className="text-xs text-primary-400 font-medium mt-0.5">
                          {f.subtitle}
                        </p>
                      </div>
                    </div>
                    <p className="text-sm text-foreground-300 leading-relaxed mb-5">
                      {f.desc}
                    </p>
                    <ul className="space-y-2">
                      {f.points.map((point) => (
                        <li
                          key={point}
                          className="flex items-start gap-2 text-sm text-foreground-300"
                        >
                          <span className="w-1.5 h-1.5 rounded-full bg-primary-500 flex-shrink-0 mt-1.5" />
                          {point}
                        </li>
                      ))}
                    </ul>
                  </div>
                  <div
                    className={`rounded-lg overflow-hidden border border-background-200/50 ${
                      f.reverse ? 'order-2 lg:order-1' : ''
                    }`}
                  >
                    <img
                      src={f.image}
                      alt={`${f.title}界面`}
                      title={`${f.title} - ${f.subtitle}`}
                      className="w-full h-56 md:h-72 object-cover object-top"
                    />
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* CTA - Platform entry point */}
        <section className="bg-primary-500 py-16 md:py-24">
          <div className="w-full px-4 md:px-8 lg:px-12 xl:px-20 max-w-[1400px] mx-auto text-center">
            <div className="w-14 h-14 flex items-center justify-center rounded-full bg-foreground-50/10 text-foreground-50 mx-auto mb-6">
              <i className="ri-external-link-line text-2xl" />
            </div>
            <h2 className="text-2xl md:text-3xl font-bold text-foreground-50 font-heading mb-4">
              立即体验网银盾智管平台
            </h2>
            <p className="text-base text-foreground-100/80 max-w-2xl mx-auto mb-10 leading-relaxed">
              全方位的 UKey 智能管理，让设备调度更高效、权限控制更精细、资金安全更有保障。
            </p>
            <a
              href={PLATFORM_URL}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-2 px-8 py-4 bg-foreground-50 text-primary-500 text-base font-semibold rounded-lg hover:bg-background-50 transition-colors whitespace-nowrap"
            >
              进入平台
              <i className="ri-arrow-right-line" />
            </a>
            <p className="mt-4 text-xs text-foreground-100/60">
              请点击上方按钮跳转至网银盾智管平台进行体验
            </p>
          </div>
        </section>

        {/* Other products */}
        <section className="py-16 md:py-24 bg-background-100">
          <div className="w-full px-4 md:px-8 lg:px-12 xl:px-20 max-w-[1400px] mx-auto">
            <div className="flex items-end justify-between">
              <div>
                <h2 className="text-xl md:text-2xl font-bold text-foreground-50 font-heading">
                  其它产品
                </h2>
                <div className="mt-4 w-12 h-0.5 bg-primary-500 rounded-full" />
              </div>
              <Link
                to="/product-center"
                className="inline-flex items-center gap-2 text-sm font-medium text-foreground-400 hover:text-primary-400 transition-colors whitespace-nowrap"
              >
                查看全部
                <i className="ri-arrow-right-line" />
              </Link>
            </div>

            <div className="mt-10 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
              {otherProducts.map((item) => (
                <Link
                  key={item.slug}
                  to={`/product-center/${item.slug}`}
                  className="group block bg-background-50 rounded-lg overflow-hidden border border-background-200/50 hover:border-primary-500/40 transition-all duration-300"
                >
                  <div className="relative w-full h-44 overflow-hidden">
                    <img
                      src={item.image}
                      alt={item.titleCn}
                      title={`${item.titleCn} ${item.titleEn}`}
                      className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-700"
                    />
                    <div className="absolute inset-0 bg-gradient-to-t from-black/50 to-transparent" />
                    <div className="absolute bottom-3 left-4 w-10 h-10 flex items-center justify-center rounded-lg bg-background-50/90 text-primary-500">
                      <i className={`${item.icon} text-lg`} />
                    </div>
                  </div>
                  <div className="p-6">
                    <h3 className="text-base md:text-lg font-bold text-foreground-50 group-hover:text-primary-400 transition-colors">
                      {item.titleCn}
                    </h3>
                    <p className="mt-2 text-sm text-foreground-300 leading-relaxed line-clamp-2">
                      {item.desc}
                    </p>
                    <div className="mt-4 inline-flex items-center gap-2 text-sm font-medium text-foreground-400 group-hover:text-primary-400 transition-colors">
                      <span>查看详情</span>
                      <i className="ri-arrow-right-line group-hover:translate-x-1 transition-transform" />
                    </div>
                  </div>
                </Link>
              ))}
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
}